import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";

export const useWorkflowsListQuery = (shopId: string) => {
  const query = $api.useQuery("get", "/shops/{shopId}/workflows", {
    params: { path: { shopId } },
  });
  return query;
};

export const useInvalidateWorkflowListQuery = (shopId: string) => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({
      queryKey: [
        "get",
        "/shops/{shopId}/workflows",
        { params: { path: { shopId } } },
      ],
    });
  };
};
